import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { PackageActionTypes, PackageActions } from '../actions/package.actions';
import {PurchaseService} from '../../../services/purchse.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';


@Injectable()
export class PackageEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private purchaseService = inject(PurchaseService);

  constructor() {}

  ReadPackages$ = createEffect(() => this.actions$.pipe(
    ofType(PackageActionTypes.GetPackages),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const params = {
        otp: user.otp,
        acode: user.acode
      };
      return this.purchaseService.ReadPackage(params).pipe(
        map((res: any) => {
          if (res.result || Array.isArray(res.msg.body)) {
            return new featureActions.LoadPackages(res.msg.body);
          } else {
            return new featureActions.GetPackagesFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetPackagesFail());
        })
      );
    })
  ));



}
